import React from 'react';
import { MapPin, Facebook, Twitter, Instagram, Github } from 'lucide-react';

const TopBar = () => {
  return (
    <div className="bg-gray-100 border-b">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-2 text-sm">
          <div className="flex items-center gap-2 text-gray-600">
            <MapPin size={16} />
            <span>No-63/1 & 63/2, Shed No-7.Karihobanahalli. Near BBMP office. Thigalarapaya. Bangalore-560073</span>
          </div>
          <div className="flex gap-3">
            <a href="#" className="text-gray-600 hover:text-yellow-500 transition-colors">
              <Facebook size={16} />
            </a>
            <a href="#" className="text-gray-600 hover:text-yellow-500 transition-colors">
              <Twitter size={16} />
            </a>
            <a href="#" className="text-gray-600 hover:text-yellow-500 transition-colors">
              <Instagram size={16} />
            </a>
            <a href="#" className="text-gray-600 hover:text-yellow-500 transition-colors">
              <Github size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;